<div class="wrapper" (change)="this.reloadCurrentRoute();">
  <small *ngIf="!uploadService.fileErr; else hint">{{ 'Portal.Hint.Goods' | translate }}</small>
  <ng-template #hint id="goodhint"><small id="goodhint">{{ 'Portal.Hint.Goods' | translate }}</small></ng-template>
  <ul>
    <li *ngFor="let gg of goodsGroup; let ind = index">
      <div id="container">
        <div style="position: relative;">
          <img mat-card-image
               loading="lazy"
               [id]="gg.code"
               class="image gg"
               src="../../../assets/imgs/foodtype/{{gg.code}}.png{{DateNow}}"
               onError="this.src='../../assets/imgs/fig-cart-empty.png';"
               width="200px"
               alt="FoodImage" />
          <input id="GoodsFileModel"
                 name="file"
                 (change)="upload($event, 'foodtype', gg)"
                 type="file" accept="image/png" #inputFile hidden>
        </div>
        <div class="group-title">
          <div class="groupname">
            {{gg.nameLatin && !share.sharemodel.isrtl ? gg.nameLatin : gg.name}}
          </div>
        </div>
      </div>
      <ul class="goods">
        <li *ngFor="let goods of gg.goods; let goodsindex = index" class="foodcard">
          <div class="foodimage">
            <div class="overaly"></div>
            <span class="goodscode">{{goods.code | persianNumber}}</span>
            <img mat-card-image
                 loading="lazy"
                 [id]="goods.code"
                 class="image"
                 src="../../../assets/imgs/{{goods.code}}.jpg{{DateNow}}"
                 onError="this.src='../../assets/imgs/fig-cart-empty.png';"
                 width="200px"
                 alt="FoodImage" />
            <input id="GoodsFileModel"
                   name="file"
                   (change)="upload($event, 'goods', goods)"
                   type="file" accept=".jpg,.jpeg" #inputFile hidden>

            <div class="centered" *ngIf="goods.stockInWeb !== '1'">{{ 'Errors.LackOfInventory' | translate }}</div>
            <div class="discounttag" *ngIf="goods.discount && goods.discount !== 0 && goods.stockInWeb === '1'">{{goods.discount}}%</div>
          </div>
          <small>{{goods.name}}</small>
        </li>
      </ul>
    </li>
  </ul>
</div>
